angular.module('picmonicng').controller('SchoolMembersController', [
  '$scope',
  '$location',
  '$http',
  '$timeout',
  'Schools',
  'UserService',
  'MetaService',
  function ($scope, $location, $http, $timeout, Schools, UserService, MetaService) {
    $scope.school_id = $location.path().split('/')[2];
    $scope.school = Schools.get({ school_id: $scope.school_id }, function () {
      MetaService.replace('%SCHOOL%', $scope.school.name);
      $scope.$emit('endInteraction');
    });
    $scope.school_users = Schools.get({
      resource: 'users',
      school_id: $scope.school_id,
    });
    $scope.UserService = UserService;

    $scope.isActive = function (route) {
      return route === ($location.path().split('/')[3] || 'home');
    };
  },
]);
